import type { Article } from '@/app_lib/types/Article';
import type {
  ArticlePreview,
  ArticlePreviewFeatured,
  ArticlePreviewGrid,
  ArticlePreviewMostPopular,
  ArticlePreviewSmall,
} from '@/app_lib/types/ArticlePreview';

type ArticleTypes =
  | Article
  | ArticlePreviewMostPopular
  | ArticlePreviewFeatured
  | ArticlePreviewGrid
  | ArticlePreview
  | ArticlePreviewSmall;

export function getExtendedArticle(article: ArticleTypes): ArticlePreview | ArticlePreviewFeatured | Article {
  const articleResult = article as Article;
  const featureTemplateHeaderImage =
    'featureTemplateHeaderImage' in articleResult && articleResult.featureTemplateHeaderImage
      ? articleResult.featureTemplateHeaderImage
      : undefined;
  const adTags = 'adTags' in articleResult && articleResult.adTags ? articleResult.adTags : { edges: [] };
  const audience = 'audience' in articleResult && articleResult.audience ? articleResult.audience : {};
  const classification =
    'classification' in articleResult && articleResult.classification
      ? articleResult.classification
      : { primaryPostTag: { databaseId: 0, name: '', url: '' } };
  const content = 'content' in articleResult && articleResult.content ? articleResult.content : '';
  const excerpt = 'excerpt' in articleResult && articleResult.excerpt ? articleResult.excerpt : '';
  const databaseId = 'databaseId' in article && typeof article.databaseId === 'number' ? article.databaseId : 0;
  const primarySectionId =
    'primarySectionId' in article && typeof article.primarySectionId === 'number' ? article.primarySectionId : 0;
  const sections =
    'sections' in article && article.sections ? article.sections : { nodes: [{ databaseId: 0, name: '', url: '/' }] };

  return {
    ...article,
    adTags,
    audience,
    classification,
    content,
    databaseId,
    excerpt,
    featureTemplateHeaderImage,
    primarySectionId,
    sections,
  } as ArticlePreview | ArticlePreviewFeatured | Article;
}
